import { BrowserModule } from '@angular/platform-browser';
import {
  NgModule,
  inject,
  provideAppInitializer
} from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { FeaturesModule } from './features/features.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpErrorInterceptor } from 'app/shared/interceptors/HttpErrorInterceptor';
import {
  JwtHelperService,
  JwtModule
} from '@auth0/angular-jwt';
import { HttpLoadingInterceptor } from 'app/shared/interceptors/HttpLoadingInterceptor';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { AuthService } from 'app/shared/services/auth.service';
import { initApp } from 'app/shared/lib/get-configuration';
import { CookieService } from 'ngx-cookie-service';
import { UiConfigService } from 'app/shared/services/ui-config.service';
import { initUiConfig } from 'app/shared/lib/get-ui-config';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import { Constants } from 'app/shared/config/constants';
import { TrimInterceptor } from 'app/shared/interceptors/TrimInterceptor';
import { fedInit } from "app/shared/lib/fed-init";
import { FedEntrypointService } from "app/shared/services/fed-entrypoint.service";

export function tokenGetter () {
  return localStorage.getItem ( Constants.localStorageKeys.reporterAccessToken );
}

@NgModule ( {
  declarations: [
    AppComponent,
  ],
  bootstrap: [ AppComponent ],
  exports: [
    SharedModule,
    FeaturesModule,
  ],
  imports: [ BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    JwtModule.forRoot ( {
      config: {
        tokenGetter,
        allowedDomains: [
          'localhost',
          'build01',
          'hqgbgofcbuild1'
        ],
        disallowedRoutes: Constants.jwtDisallowedRoutes,
      }
    } ),
    FormsModule,
    ReactiveFormsModule,
    FeaturesModule,
    ToastrModule.forRoot ( {
      toastClass: 'reporter-toast',
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    } ),
    InfiniteScrollModule ],
  providers: [
    provideAppInitializer ( () => {
      const initializerFn = ( initUiConfig ) ( inject ( HttpClient ), inject ( UiConfigService ), inject ( AuthService ), inject ( Router ) );
      return initializerFn ();
    } ),
    provideAppInitializer ( () => {
      const initializerFn = ( initApp ) ( inject ( HttpClient ), inject ( ConfigurationService ) );
      return initializerFn ();
    } ),
    provideAppInitializer ( () => {
      const initializerFn = ( fedInit ) ( inject ( FedEntrypointService ) );
      return initializerFn ();
    } ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrimInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true
    },
    JwtHelperService,
    CookieService,
    provideHttpClient ( withInterceptorsFromDi () ),
  ]
} )
export class AppModule {
}
